
import { Box, Typography, Grid2 as Grid, useTheme, useMediaQuery, Link } from "@mui/material";
import './company.css';
import CompanyH from "../../../assets/images/Company_Home.png";
import { useNavigate } from "react-router-dom";

function Company() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const widthText = isMobile ? "100%" : "75%";
  const navigate = useNavigate();

  return (
    <Box className="company-container">
      <Typography className="title"
        sx={{
          color: "#E66671",
          fontWeight: "bold",
          textAlign: "center",
          fontFamily: "BloodOrange, sans-serif"
        }}
      >
        ✧ La receta de nuestra historia ✧
      </Typography>
      <Grid container spacing={2} className="company-content" >
        <Grid size={isMobile ? 12 : 6} className="company-image-section">
          <img src={CompanyH} className="company-image" alt="company-image" />
        </Grid>
        <Grid size={isMobile ? 10 : 6} className="text-section">
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 4, width: widthText }}
          >
            Desde 1959, Marián® se ha consolidado como un símbolo de calidad y autenticidad mexicana.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Nacida en la emblemática colonia Roma de la Ciudad de México, la marca se originó por el profundo amor por las galletas y la búsqueda incansable del sabor perfecto.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Con el tiempo, esa pasión se tradujo en una receta única que conquistó corazones y paladares.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Comenzando como un emprendimiento de venta casa a casa, su éxito creció de manera orgánica, gracias a los clientes que, una vez probadas las delicias, regresaban para seguir disfrutando de ese exquisito sabor.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Así, el sueño del fundador se hizo realidad: <b>transmitir una pasión por la calidad y el sabor.</b>
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2, width: widthText }}
          >
            Su misión es simple: ofrecer galletas que despierten emociones y recuerdos, productos elaborados con amor, dedicación y que en cada bocado te transporten a esos momentos especiales.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2 }}
          >
            Porque cada galleta cuenta una historia.
          </Typography>
          <Typography
            className="company-text"
            variant="body1"
            sx={{ mt: 2 }}
          >
            Marián®, reinventamos la pasión por el sabor.
          </Typography>
          <Link
            onClick={() => navigate('empresa')}
            underline="none"
            sx={{
              fontWeight: "bold",
              color: "#E66671",
              fontSize: "14px",
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              }
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
            onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
          >
            VER MÁS
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Company;